import script from "./ChecksTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecksTable.vue?vue&type=script&setup=true&lang=js"

import "./ChecksTable.vue?vue&type=style&index=0&id=037d3195&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037d3195"]])

export default __exports__